import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'learning.updates.title',
    defaultMessage: 'Updates',
    description: 'The title of the updates tab.',
  },
  loading: {
    id: 'learning.updates.loading',
    defaultMessage: 'Loading updates...',
    description: 'Screen reader text while updates are loading.',
  },
  noUpdates: {
    id: 'learning.updates.noUpdates',
    defaultMessage: 'No updates yet.',
    description: 'Message shown when there are no course updates available.',
  },
});

export default messages;

